import { env } from "@quenti/env/client";

export const WEBSITE_URL = env.NEXT_PUBLIC_WEBSITE_URL || "https://quenti.io";
export const APP_URL = env.NEXT_PUBLIC_APP_URL;
